<div class="picklist-packing-table__wrapper" *ngIf="!loading; else loader">
  <div *ngIf="!updatingStatus; else pageLoader"></div>
  <table class="lum-table lum-table--classic striped">
    <thead>
      <th>
        <mat-checkbox
          class="lum-checkbox"
          [checked]="toggledAll"
          (change)="toggleAll($event)"
        >
        </mat-checkbox>
      </th>
      <th>Order #</th>
      <th>Order Date</th>
      <th>Product Name</th>
      <th>Ordered Qty</th>
      <th>Picked Qty</th>
      <th>Verified At</th>
      <th>Verified By</th>
      <th>&nbsp;</th>
    </thead>
    <tbody>
      <ng-container
        *ngFor="let row of data; let rowIndex = index; trackBy: trackById"
      >
        <tr
          *ngFor="let item of row.items; let i = index; trackBy: trackByValue"
          [class]="{
            'order-flagged': row.flag,
            'row-invalid': item.flag,
            'bg-gray-100': rowIndex % 2 === 1,
          }"
        >
          <td>
            <mat-checkbox
              *ngIf="!i"
              class="lum-checkbox"
              [checked]="row.checked || false"
              (change)="toggleItem(row, $event)"
            >
            </mat-checkbox>
          </td>
          <td>
            <a (click)="row.expanded = !row.expanded" class="href-expand-detail">
              {{ !i ? row.orderNumber : '' }}
            </a>
          </td>
          <td>{{ !i ? (row.orderDate | date: 'MMM d, y, h:mm a') : '' }}</td>
          <td>[{{ item?.sku }}] {{ item?.productName }}</td>
          <td>{{ item?.quantity | decimalPlaces }}</td>
          <td>{{ item?.pickedQuantity | decimalPlaces }}</td>
          <td>{{ !i ? (row.verifiedAt | date: 'MMM d, y, h:mm a') : '' }}</td>
          <td>
            {{ !i && row.verifiedBy ? row.verifiedBy.firstName : '' }}
            {{ !i && row.verifiedBy ? row.verifiedBy.lastName : '' }}
          </td>
          <td class="flex justify-content-end">
            <lum-picklist-packing-table-actions
              [showActions]="showPicklistActions"
              [data]="row"
              [key]="i"
              [picklist]="picklist"
              [loadingShipItems]="loadingShipItems"
              [loadingBulkShip]="loadingBulkShip"
              (verifyEvent)="verifyEvent.emit($event)"
              (shipEvent)="shipEvent.emit($event)"
              (onHoldEvent)="onHoldEvent.emit($event)"
              (printLabelEvent)="printLabelEvent.emit($event)"
              (printLabelWithPackingSlipEvent)="
                printLabelWithPackingSlipEvent.emit($event)
              "
              (exportPackingSlipEvent)="exportPackingSlipEvent.emit($event)"
              (flagOrderEvent)="flagOrderEvent.emit($event)"
            ></lum-picklist-packing-table-actions>
          </td>
        </tr>
        <tr *ngIf="row.expanded && row.invoice">
          <td [attr.colspan]="packingTableColSpan.QUICK_FULFILLMENT_ENABLED">
            <lum-picklist-packing-table-details
              (exportPackingSlipEvent)="exportPackingSlipEvent.emit($event)"
              [orderData]="row"
            ></lum-picklist-packing-table-details>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<ng-template #loader>
  <div class="w-100">
    <mat-spinner diameter="20" class="mx-auto"></mat-spinner>
  </div>
</ng-template>

<ng-template #pageLoader>
  <div class="w-100 page-loader">
    <mat-spinner diameter="20" class="mx-auto"></mat-spinner>
  </div>
</ng-template>
